var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08237 2.36651H4.74263C3.40661 2.36651 2.7386 2.36651 2.2283 2.62652C1.77944 2.85523 1.4145 3.22017 1.18579 3.66903C0.925781 4.17933 0.925781 4.84734 0.925781 6.18336V12.8628C0.925781 14.1989 0.925781 14.8669 1.18579 15.3772C1.4145 15.826 1.77944 16.191 2.2283 16.4197C2.7386 16.6797 3.40661 16.6797 4.74263 16.6797H11.4221C12.7581 16.6797 13.4261 16.6797 13.9364 16.4197C14.3853 16.191 14.7502 15.826 14.9789 15.3772C15.239 14.8669 15.239 14.1989 15.239 12.8628V9.5231M5.69682 11.9086H7.02838C7.41736 11.9086 7.61185 11.9086 7.79488 11.8647C7.95716 11.8257 8.11229 11.7615 8.25458 11.6743C8.41507 11.5759 8.5526 11.4384 8.82765 11.1633L16.4317 3.55928C17.0905 2.90053 17.0905 1.83249 16.4317 1.17375C15.773 0.515002 14.7049 0.515001 14.0462 1.17375L6.44211 8.77781C6.16705 9.05287 6.02952 9.1904 5.93117 9.35089C5.84398 9.49318 5.77972 9.64831 5.74076 9.81059C5.69682 9.99362 5.69682 10.1881 5.69682 10.5771V11.9086Z",
    stroke: "#EB5B1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f68c4d4af9663b31e881f9ed6a7f7cd7.svg";
export { ForwardRef as ReactComponent };